/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { RSocketStreamBaseService } from './RSocketStreamBaseService';
import { LapDeltaData, OriginType, SanctioningBodyEnum } from 'models/viewModels';
import { StreamRequestType } from './RSocketObject';
import axiosConfig, { ApiRequestType } from 'axiosConfig/axiosConfig';

class LapDeltaDataService extends RSocketStreamBaseService<LapDeltaData[], LapDeltaData> {
  protected async getStreamHistoryRequest(): Promise<LapDeltaData[]> {
    return axiosConfig(ApiRequestType.StreamMetricsApi)
      .post('/rest/backfill/lapDelta', this.request)
      .then((response) => {
        const backfillResponse = response.data as LapDeltaData[];
        return backfillResponse;
      })
      .catch(() => {
        return [];
      });
  }

  protected onDataCallback = async (response: LapDeltaData) => {
    const lapDeltaData = response;
    if (this.listeners.size > 0) {
      const prevLapDeltaData = this.localCache;
      const newLapDeltaData = prevLapDeltaData.filter((item) => item.vehicleNumber !== lapDeltaData.vehicleNumber);
      newLapDeltaData.push(lapDeltaData);

      // Update vehicleBestLapDeltaMap with the newest lapDeltaData
      newLapDeltaData.forEach((data) => {
        const bestLapDeltas = lapDeltaData.deltaMetadata.vehicleBestLapDeltaMap;
        data.deltaMetadata = {
          ...data.deltaMetadata,
          vehicleBestLapDeltaMap: bestLapDeltas,
        };
      });
      this.localCache = newLapDeltaData;
    }
  };

  async start() {
    this.delay = 1000;
    super.start();
  }
}

export const lapDeltaDataServiceCollection: Map<SanctioningBodyEnum, Map<OriginType, LapDeltaDataService>> = new Map(
  (Object.values(SanctioningBodyEnum) as SanctioningBodyEnum[])
    .filter((x) => typeof x === 'number')
    .map((sanctioningBody) => [
      sanctioningBody,
      new Map(
        (Object.values(OriginType) as OriginType[])
          .filter((x) => typeof x === 'number')
          .map((source: OriginType) => [
            source,
            new LapDeltaDataService({
              route: 'stream.lapDelta',
              connectionType: StreamRequestType.MotorsportsStreamApi,
              originType: source,
              sanctioningBody: sanctioningBody,
            }),
          ])
      ),
    ])
);
